import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const diaperListApi = async (data) => {
  const endPoint = `admin/diaper/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
